module.exports = __webpack_public_path__ + "img/orangeTick.18f32819.png";